import Appsignal from "@appsignal/javascript"

new Appsignal({ key: import.meta.env.VITE_APPSIGNAL_KEY })
